var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "checkout-step-wrapper" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row" }, [
        _c("ol", { staticClass: "checkout-step-list" }, [
          _c(
            "li",
            {
              staticClass: "checkout-step",
              class: { "checkout-step--active": _vm.stepIndex < 4 },
            },
            [_vm._v("Your Holiday")]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              staticClass: "checkout-step",
              class: { "checkout-step--active": _vm.stepIndex === 4 },
            },
            [_vm._v("Your Details")]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              staticClass: "checkout-step",
              class: { "checkout-step--active": _vm.stepIndex > 4 },
            },
            [_vm._v("Payment")]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }